import { MutationTree } from 'vuex';
import { DatV2 } from 'ctp-toll-domain';
import { FETCH_DATS,
  DatsState,
  UPDATE_DATS_STATE,
  SET_ERROR,
  IDatsStatePayload,
  SET_NOTIFICATION,
  INotification } from './types';

const mutations: MutationTree<DatsState> = {
  [UPDATE_DATS_STATE](
    state: DatsState,
    stateToUpdate: IDatsStatePayload
  ) {
    const {
      view,
      stateKey,
      stateValue
    } = stateToUpdate;

    state.datsState[stateKey][view] = stateValue;
  },
  [FETCH_DATS](state: DatsState, payload: DatV2[]) {
    state.dats = payload;
  },
  [SET_ERROR](state: DatsState, payload) {
    state.errorMessage = payload;
  },
  [SET_NOTIFICATION](state: DatsState, payload: INotification | undefined) {
    state.notification = payload;
  }
};

export default mutations;
